// components/Logo.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { useContent } from 'context/ContentContext';

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const ImageWrapper = styled.div`
  height: clamp(4rem, 3vw, 5rem);
  aspect-ratio: 2.4;

  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
`;

const BrandName = styled.span`
  font-family: ${(props) => props.theme.fonts.primary};
  font-weight: 700;
  color: ${(props) => props.theme.colors.primary};
  font-size: 2.2rem;

  ${({ theme }) => theme.mediaQueries.md} {
    font-size: 2.8rem;
  }
`;

const Logo = ({ logoSrc, size = 'medium', showText = false }) => {
  const { title } = useContent();
  return (
    <LogoContainer>
      <ImageWrapper>
        <img src={logoSrc} alt={`${title} Logo`} loading="lazy" />
      </ImageWrapper>
      {showText && <BrandName size={size}>{title}</BrandName>}
    </LogoContainer>
  );
};

Logo.propTypes = {
  logoSrc: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  showText: PropTypes.bool,
};

export default Logo;
